// extracted by mini-css-extract-plugin
module.exports = {"navItem":"MenuItems_navItem__2W0DM","navLink":"MenuItems_navLink__3B-El"};